module.exports = __webpack_public_path__ + "img/s4-1.144afad6.jpg";